import React from 'react';
import ScrollReveal from './ScrollReveal';
import './LogoMarquee.css';
import { FaHospital, FaVial, FaBuilding, FaChartLine, FaIndustry, FaFlask, FaMicrochip, FaStore, FaSpa } from 'react-icons/fa';

const row1 = [
  { icon: <FaVial />, name: 'Agappe Diagnostics Ltd' },
  { icon: <FaHospital />, name: 'Baby Memorial Group of Hospitals' },
  { icon: <FaHospital />, name: 'Rajagiri Hospital' },
  { icon: <FaHospital />, name: 'Believers Church Medical College Hospital' },
  { icon: <FaHospital />, name: 'MES Medical College Hospital' },
  { icon: <FaHospital />, name: "St. Mary's Hospital" },
  { icon: <FaHospital />, name: 'Meitra Hospital' },
  { icon: <FaHospital />, name: 'Star Hospital' },
  { icon: <FaHospital />, name: 'Naruvi Hospital' }
];

const row2 = [
  { icon: <FaBuilding />, name: 'CFCICI' },
  { icon: <FaChartLine />, name: 'Supra Pacific Financial Ltd' },
  { icon: <FaIndustry />, name: 'KSE Limited' },
  { icon: <FaFlask />, name: 'Plant Lipids Pvt Ltd' },
  { icon: <FaIndustry />, name: 'Nitta Gelatine India Limited' },
  { icon: <FaMicrochip />, name: 'Emsyne Technologies Pvt Ltd (Muthoot)' },
  { icon: <FaStore />, name: 'MyG India' },
  { icon: <FaSpa />, name: 'Tulah Wellness Clinic' }
];

const LogoMarquee = () => {
  return (
    <ScrollReveal as="section" className="logo-marquee-section" variant="fadeUp">
      <h3 className="marquee-title">Trusted by Healthcare, Finance, and Industry Leaders</h3>
      
      <div className="marquee-container">
        {/* Row 1: Right to Left */}
        <div className="marquee-track">
          <div className="marquee-content">
            {row1.map((logo, index) => (
              <div key={`row1-a-${index}`} className="logo-item">
                <span className="logo-icon">{logo.icon}</span>
                <span className="logo-name">{logo.name}</span>
              </div>
            ))}
          </div>
          <div className="marquee-content" aria-hidden="true">
            {row1.map((logo, index) => (
              <div key={`row1-b-${index}`} className="logo-item">
                <span className="logo-icon">{logo.icon}</span>
                <span className="logo-name">{logo.name}</span>
              </div>
            ))}
          </div>
        </div>
        
        {/* Row 2: Left to Right (Reverse) */}
        <div className="marquee-track reverse">
          <div className="marquee-content">
            {row2.map((logo, index) => (
              <div key={`row2-a-${index}`} className="logo-item">
                <span className="logo-icon">{logo.icon}</span>
                <span className="logo-name">{logo.name}</span>
              </div>
            ))}
          </div>
          <div className="marquee-content" aria-hidden="true">
            {row2.map((logo, index) => (
              <div key={`row2-b-${index}`} className="logo-item">
                <span className="logo-icon">{logo.icon}</span>
                <span className="logo-name">{logo.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
};

export default LogoMarquee;
